import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Button, logout } from "clavis-nxt-components-custdevtm";
import "./LogOutModal2.scss";

const resolveGatekeeperConfig = context =>
  context &&
  Object.hasOwn(context, "modules") &&
  Object.hasOwn(context.modules, "gatekeeper")
    ? context.modules.gatekeeper
    : null;

export const LogOutQuestionModal = props => {
  const { t } = useTranslation();

  const memoizedLogout = useCallback(
    () => logout(resolveGatekeeperConfig(props.moduleConfigContext)),
    [logout, resolveGatekeeperConfig, props.moduleConfigContext]
  );

  return (
    <div className={"logout-modal-container"}>
      <Button buttonType="primary" onClick={memoizedLogout}>
        {t("platform.logout.buttonYes")}
      </Button>
      <Button buttonType="secondary" onClick={props.close}>
        {t("platform.logout.buttonNo")}
      </Button>
    </div>
  );
};
